module.exports = __webpack_public_path__ + "img/sw.1e0d582f.png";